import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/*
NAME: RowContainer
DESC: Uma div com o CSS padrão para servir de container com orientação horizontal para os componentes filhos.
props:
- - - - Default
- style: Object, style object to overwrite this component style
- styles: Object, alias for style (compatibilidade)
- children: Component, renders component childs
NOTES:
*/

function RowContainer({styles, style, children}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%',
            boxSizing: 'border-box',
            ...styles,
            ...style,
            ...(isMobile ? {
                flexDirection: 'column',
                alignItems: 'stretch',
                minWidth: 0,
                maxWidth: '100%',
            } : {
                minWidth: 0,
            }),
        }}>
            {children}
        </div>
    );
}

export default RowContainer;
